import {IFetchRoomProtection} from '../../../incase-domain/rooms/room.player';
import {TypedTranslation} from '../../../i18n';

export const SET_ROOM_PROTECTION = 'SET_ROOM_PROTECTION';
export const SET_ROOM_INFO_MODAL = 'SET_ROOM_INFO_MODAL';
export const SET_ROOM_PASSWORD_ERROR = 'SET_ROOM_PASSWORD_ERROR';

export interface IRoomInfoModal {
    open: boolean;
    title: TypedTranslation | '';
    description: TypedTranslation | '';
    // Shown in bold in place of <params/> in the description
    descriptionParams?: string[];
}

export interface ISetRoomProtectionAction {
    type: typeof SET_ROOM_PROTECTION;
    protection: IFetchRoomProtection;
}

export interface ISetRoomInfoModalAction {
    type: typeof SET_ROOM_INFO_MODAL;
    modal: IRoomInfoModal;
}

export interface ISetRoomPasswordErrorAction {
    type: typeof SET_ROOM_PASSWORD_ERROR;
    error: TypedTranslation | null;
}
